import { useGetSizesProps } from "./types";
import { Button } from "primereact/button";
import { UnitsDescriptionRead } from "@types";

export const useGetUnitDescription = ({
  onEdit,
  onDelete,
}: useGetSizesProps) => {
  const handleDeleteClick = (rowData: UnitsDescriptionRead) => {
    if (rowData && rowData.id) {
      onDelete(rowData.id);
    }
  };

  const columns = [
    { field: "unit.location.locationName", header: "Location Name" },
    {
      field: "unit",
      header: "Name",
      body: (rowData: UnitsDescriptionRead) => rowData.unit?.name ?? "-",
    },
    { field: "unit.size.width", header: "Width" },
    { field: "unit.size.length", header: "Length" },
    { field: "unit.size.description", header: "Size Description" },
    {
      field: "unit",
      header: "Sq Footage",
      body: (rowData: UnitsDescriptionRead) => rowData.unit?.sqFootage ?? "-",
    },
    { field: "floor", header: "Floor" },
    { field: "description1", header: "Description 1" },
    { field: "description2", header: "Description 2" },
    { field: "description3", header: "Description 3" },
    { field: "description4", header: "Description 4" },
    {
      field: "actions",
      header: "",
      body: (rowData: UnitsDescriptionRead) => (
        <div className="flex gap-2">
          <Button
            icon="pi pi-pencil"
            className="p-button-text p-button-sm"
            onClick={() => onEdit(rowData)}
          />
          <Button
            icon="pi pi-trash"
            rounded
            outlined
            severity="danger"
            className="p-button-text p-button-sm"
            onClick={() => handleDeleteClick(rowData)}
          />
        </div>
      ),
    },
  ];

  return { columns };
};
